import React, { Component } from "react";
import "rc-datepicker/lib/style.css";
import {
    MDBBreadcrumb,
    MDBBreadcrumbItem,
    MDBCard,
    MDBCardBody,
    MDBBtn,
    MDBTable,
} from "mdbreact";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { trackPromise } from "react-promise-tracker";
import Swal from "sweetalert2";

class Edit_prm_jalur extends Component {
    constructor(props) {
        super(props);

        const { location } = this.props;
        const { state } = location;
        const { data } = state;

        this.state = {
            id: "",
            data: data,
            isEdit: false,
            subdomain: data.subdomain,
            user_level: data.user_level,
            listJalur: [],
            namaJalur: data.nama_jalur || "",
            buttonName: "Simpan",
        }
    }

    async componentDidMount() {
        await this.onFetchData();
    }

    async onFetchData() {

        await trackPromise(
            fetch(global.variable.LINK_API + "param/jalur/list", {
                method: "post",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + global.cookies.get("access_token"),
                },
                body: JSON.stringify({ subdomain: this.state.subdomain }),
            })
                .then((response) => response.json())
                .then((res) => {
                    if (res.code === 200) {
                        this.setState({ listJalur: res.data, is_show: true });
                    } else {
                        global.swal("Info", res.message, "info");
                    }
                })
        );
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    onClickCancel() {
        this.setState({
            isEdit: false,
            id: "",
            namaJalur: "",
            buttonName: "Simpan",
        })
    }

    onClickEdit(val) {
        window.scrollTo(0, 0);
        console.log(val.id, val.nama_jalur);
        this.setState({
            isEdit: true,
            id: val.id,
            namaJalur: val.nama_jalur,
            buttonName: "Ubah",
        })
    }

    onClickDelete(id) {
        global.swal({
            text: "Hapus Jalur Pendaftaran ini?",
            closeOnEsc: false,
            closeOnClickOutside: false,
            buttons: ["Batal", { text: "Hapus", closeModal: false }],
        }).then((confirm) => {
            if (!confirm) {
                return
            }
            fetch(global.variable.LINK_API + "param/jalur/delete/" + id, {
                method: "delete",
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + global.cookies.get("access_token"),
                },
            })
                .then((response) => response.json())
                .then((res) => {
                    if (res.code === 200) {
                        window.location.reload();
                    } else {
                        global.swal("Error", res.message, "info");
                    }
                });
        })
    }

    onClickSubmit = (event) => {
        event.preventDefault();
        Swal.fire({
            title: "Mohon Tunggu Sebentar !",
            allowOutsideClick: false,
            onBeforeOpen: () => {
                Swal.showLoading();
            },
        });
        fetch(global.variable.LINK_API + 'param/jalur/create',
            {
                method: 'post',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + global.cookies.get('access_token'),
                },
                body: JSON.stringify({
                    subdomain: this.state.subdomain,
                    nama_jalur: this.state.namaJalur,
                }),
            })
            .then(response => response.json())
            .then(resData => {
                Swal.close();
                if (resData.code === 200) {
                    global.swal("Success", resData.message, "success",)
                        .then((value) => {
                            this.onClickCancel();
                            this.onFetchData();
                        });
                } else {
                    global.swal("Error", resData.message, "info")
                }

            }).catch(err => {
                Swal.close();
                if (err) {
                    if (err.code !== 403) {
                        global.swal("Error", err.message, "info")
                    }
                } else {
                    global.swal.stopLoading();
                    global.swal.close();
                }
            });
    }

    onClickUpdate = (event) => {
        event.preventDefault();
        Swal.fire({
            title: "Mohon Tunggu Sebentar !",
            allowOutsideClick: false,
            onBeforeOpen: () => {
                Swal.showLoading();
            },
        });
        fetch(global.variable.LINK_API + 'param/jalur/update',
            {
                method: 'post',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + global.cookies.get('access_token'),
                },
                body: JSON.stringify({
                    id: this.state.id,
                    nama_jalur: this.state.namaJalur,
                }),
            })
            .then(response => response.json())
            .then(resData => {
                Swal.close();
                if (resData.code === 200) {
                    global.swal("Success", resData.message, "success",)
                        .then((value) => {
                            this.onClickCancel();
                            this.onFetchData();
                        });
                } else {
                    global.swal("Error", resData.error, "info")
                }

            }).catch(err => {
                Swal.close();
                if (err) {
                    if (err.code !== 403) {
                        global.swal("Error", "Koneksi ke server gagal.", "info")
                    }
                } else {
                    global.swal.stopLoading();
                    global.swal.close();
                }
            });
    }

    render() {
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="divContainter">
                                    <MDBCard className="mb-5">
                                        <MDBCardBody>
                                            <MDBBreadcrumb color="cyan lighten-4">
                                                <MDBBreadcrumbItem active>
                                                    <a href="/home">Home</a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    <a href="/pengaturanunit">Pengaturan Unit</a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem>
                                                    Pengaturan Jalur
                                                </MDBBreadcrumbItem>
                                            </MDBBreadcrumb>

                                            <form onSubmit={this.state.isEdit ? this.onClickUpdate : this.onClickSubmit}>
                                                <div>
                                                    <div className="form-row">
                                                        <div className="col-md-6">
                                                            <label style={{ fontWeight: 'bold' }}>Subdomain</label>
                                                            <input
                                                                className="form-control"
                                                                type="Text"
                                                                name="jalur"
                                                                value={this.state.subdomain || ""}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label>
                                                                Nama Jalur Pendaftaran <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                name="namaJalur"
                                                                maxLength="100"
                                                                value={this.state.namaJalur || ""}
                                                                onChange={this.onChange}
                                                                autoCorrect="off"
                                                                autoComplete="off"
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <br></br>
                                                <div className="form-row">
                                                    {this.state.isEdit && (
                                                        <div className="col-md-6">
                                                            <MDBBtn color="warning" block type="button" onClick={() => this.onClickCancel()}>
                                                                Cancel
                                                            </MDBBtn>
                                                        </div>
                                                    )}
                                                    <div className={this.state.isEdit ? "col-md-6" : "col-md-12"}>
                                                        <MDBBtn color="primary" block type="submit" >
                                                            {this.state.buttonName}
                                                        </MDBBtn>
                                                    </div>
                                                </div>
                                            </form>
                                            <br></br>
                                            <label htmlFor="exampleForm2" style={{ fontWeight: 'bold' }}>Daftar Jalur Pendaftaran</label>
                                            <MDBTable bordered>
                                                <thead className="blue-grey lighten-4">
                                                    <tr>
                                                        <th style={{ textAlign: "center" }}>No</th>
                                                        <th style={{ textAlign: "center" }}>Nama Jalur Pendaftaran</th>
                                                        <th style={{ textAlign: "center" }}>Opsi</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.listJalur.map((list, idx) => {
                                                        return (
                                                            <tr key={idx}>
                                                                <td style={{ textAlign: "center", width: "1%" }}>{idx + 1}</td>
                                                                <td>
                                                                    {list.nama_jalur}
                                                                </td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    <button className="btn btn-warning" style={style.button} onClick={() => this.onClickEdit(list)}>
                                                                        <FontAwesomeIcon icon={faEdit} ></FontAwesomeIcon>
                                                                    </button>
                                                                    <button className="btn btn-danger" style={style.button} onClick={() => this.onClickDelete(list.id)}>
                                                                        <FontAwesomeIcon icon={faTrash} ></FontAwesomeIcon>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </MDBTable>
                                        </MDBCardBody>
                                    </MDBCard>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const style = {
    button: {
        backgroundColor: '#28a745',
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        borderRadius: '5px',
        cursor: 'pointer',
    },
}

export default Edit_prm_jalur;